import React, { useState, useEffect } from "react";
import axios from "axios";

const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false); // to toggle modal
  const [editData, setEditData] = useState({}); // to store current offer being edited

  const [formData, setFormData] = useState({
    title: "",
    discount: "",
    coupon_code: "",
    message: "",
    description: "",
    tag: "",
  });
  const [feedback, setFeedback] = useState("");

  const fetchOffers = () => {
    axios
      .get("https://gantasoft.in/cab-g/dev/admin/alloffers.php")
      .then((response) => setOffers(response.data))
      .catch((error) => console.error("Error fetching offers:", error));
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const emptyField = Object.values(formData).some((v) => !v);
    if (emptyField) return setFeedback("All fields are required");

    axios
      .post("https://gantasoft.in/cab-g/dev/admin/create_offer.php", formData)
      .then(() => {
        setFeedback("Offer submitted");
        setFormData({
          title: "",
          discount: "",
          coupon_code: "",
          message: "",
          description: "",
          tag: "",
        });
        setShowForm(false);
        fetchOffers();
      })
      .catch(() => setFeedback("Error submitting offer"));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = () => {
    axios
      .post("https://gantasoft.in/cab-g/dev/admin/update_cupons.php", editData) // Replace with your actual API endpoint
      .then(() => {
        setShowEditModal(false);
        setEditData({});
        fetchOffers(); // Refresh the list after saving
      })
      .catch(() => alert("Error updating offer"));
  };

  const handleEditClick = (offer) => {
    setEditData(offer); // sets selected offer in modal form
    setShowEditModal(true); // opens the modal
  };

  return (
    <div className=" mx-auto px-4 py-10">
      <button
        onClick={() => setShowForm(true)}
        className="bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2 rounded-lg shadow"
      >
        + Add Offer
      </button>

      {/* Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg relative shadow-lg">
            <button
              onClick={() => setShowForm(false)}
              className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-red-600"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-green-700">
              Add New Offer
            </h2>
            {feedback && (
              <p className="text-sm mb-2 text-blue-500">{feedback}</p>
            )}
            <form onSubmit={handleSubmit} className="space-y-3">
              {[
                "title",
                "discount",
                "coupon_code",
                "message",
                "description",
                "tag",
              ].map((field) => (
                <input
                  key={field}
                  name={field}
                  placeholder={field.replace(/_/g, " ")}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-400"
                />
              ))}
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700"
              >
                Submit Offer
              </button>
            </form>
          </div>
        </div>
      )}

      {showEditModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg relative shadow-lg">
            <button
              onClick={() => {
                setShowEditModal(false);
                setEditData({});
              }}
              className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-red-600"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-yellow-600">
              Edit Offer
            </h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleEditSave();
              }}
              className="space-y-3"
            >
              {[
                "title",
                "discount",
                "coupon_code",
                "message",
                "description",
                "tag",
              ].map((field) => (
                <input
                  key={field}
                  name={field}
                  placeholder={field.replace(/_/g, " ")}
                  value={editData[field] || ""}
                  onChange={handleEditChange}
                  className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                />
              ))}
              <button
                type="submit"
                className="w-full bg-yellow-500 text-white py-2 rounded-md hover:bg-yellow-600"
              >
                Save Changes
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Offers List */}
      <h3 className="text-2xl font-semibold mt-10 mb-6 text-left text-gray-800">
        All Offers
      </h3>

      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 gap-6">
        {offers.map((offer, index) => (
          <div
            key={index}
            className="w-full max-w-full bg-[#08B10E] text-black rounded-2xl border border-green-800 p-6 shadow-lg hover:shadow-xl hover:scale-[1.03] transition-all duration-300"
          >
            <h4 className="text-2xl font-extrabold mb-3 truncate">
              {offer.title || "Untitled Offer"}
            </h4>
            <ul className="space-y-2 text-base">
              {Object.entries(offer).map(
                ([key, value]) =>
                  value &&
                  key !== "title" && (
                    <li key={key}>
                      <span className="font-semibold capitalize">
                        {key.replace(/_/g, " ")}:
                      </span>{" "}
                      {value}
                    </li>
                  )
              )}
            </ul>
            <button
              onClick={() => handleEditClick(offer)} // ✅ this is correct
              className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded"
            >
              EDIT
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offer;
